import { PageError } from 'components/shared';
import PageLoader from 'components/shared/PageLoader';
import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { Helmet } from 'react-helmet';
import NPALayout from './NPALayout';

const ClerkScreenView = () => {
  const {
    AuctionStore: { getLayoutSettingByProp, setProperty },
  } = useStores();
  const settings = getLayoutSettingByProp('layoutType', 'Clerk');
  setProperty('onClerkScreen', true);

  if (!settings || !settings?.layout) return <PageLoader />;

  if (settings?.layout.indexOf('Clerk Screen') > -1) {
    return (
      <>
        <Helmet>
          <title>Clerk Screen</title>
        </Helmet>
        <NPALayout />
      </>
    );
  }
  return <PageError />;
};

export default observer(ClerkScreenView);
